<app-loader class="loader-dialog" *ngIf="loading"></app-loader>
<div role="main">
    <div class="modal-header justify-content-center">
        <div class="modal-title">
        </div>
        <button type="button" class="btn btn-secondary" class="btn-close" [disabled]="loading" aria-label="Close" (click)="closeModal('Cancel')"></button>
    </div>
    <div class="modal-body">
        <h1 class="modal-text" id="confirm-modal-title">{{modalMessageText}}</h1>
    </div>
    <div class="modal-footer">
        <button type="button" *ngIf="showCancelButton" class="btn btn-outline-primary w-25" [disabled]="loading" (click)="closeModal('Cancel')">{{cancelButtonText}}</button>
        <button type="button" *ngIf="showOkButton" class="btn btn-primary ms-2 w-25" [disabled]="loading" (click)="deleteClinic()">{{okButtonText}}</button>
    </div>
  </div>